export const getTokenExID = () => {
  return process.env.REACT_APP_TOKEN_EX_ID;
};
export const getTokenExSecretKey = () => {
  return process.env.REACT_APP_TOKEN_EX_SECRET_KEY;
};
export const getTokenExScheme = () => {
  return process.env.REACT_APP_TOKEN_EX_SCHEME;
};

export const getPaypalHostUrl = () => {
  return process.env.REACT_APP_PAYPAL_HOST_URL;
};
export const getPaypalClientId = () => {
  return process.env.REACT_APP_PAYPAL_CLIENT_ID;
};
export const getPaypalClientSecret = () => {
  return process.env.REACT_APP_PAYPAL_CLIENT_SECRET;
};

export const getChargBeeSiteName = () => {
  return process.env.REACT_APP_CHARGEBEE_SITE_NAME;
};
export const getChargBeeUserName = () => {
  return process.env.REACT_APP_CHARGEBEE_USER_NAME;
};

export const paymentMode = {
  NONE: 0,
  CHARGEBEE: 1,
  PAYPAL: 2,
  APPLEPAY: 3,
  GOOGLEPAY: 4,
};

const SUPPORTED_CURRENCIES = ["USD", "GBP", "EUR", "JPY"];

export const getSupportedCurrency = (currencyCd) => {
  const currency = currencyCd?.toUpperCase();

  return SUPPORTED_CURRENCIES.includes(currency) ? currency : "USD";
};

const ZERO_DECIMAL_CURRENCIES = new Set(["JPY"]);

export const getAmountInSmallestUnit = (amount, currencyCd) => {
  const currency = getSupportedCurrency(currencyCd);

  return ZERO_DECIMAL_CURRENCIES.has(currency)
    ? amount
    : Math.round(amount * 100);
};

export const AUTHORIZATION_AMOUNTS = {
  USD: 1,
  GBP: 1,
  EUR: 1,
  JPY: 100,
};

export const getAuthorizationAmount = (currencyCd) => {
  const currency = currencyCd?.toUpperCase();

  return AUTHORIZATION_AMOUNTS[currency] ?? AUTHORIZATION_AMOUNTS.USD;
};

export const getAuthorizationPaymentParams = (
  currencyCD,
  paymentMethodType,
) => {
  const supportedCurrency = getSupportedCurrency(currencyCD);

  const authorizationAmount = getAuthorizationAmount(supportedCurrency);

  return {
    amount: getAmountInSmallestUnit(authorizationAmount, supportedCurrency),
    currencyCode: supportedCurrency,
    paymentMethodType,
  };
};
